<!--
 * @Description: 
 * @Author: Lynn Qin
 * @Date: 2021-05-13 13:49:09
 * @LastEditTime: 2022-04-12 14:27:47
-->
<template lang="pug">
    el-dialog(:title="$t('changePassword')" :visible="visible" @close="handleCloseElementDialog" width="380px" center :append-to-body="true" :show-close="false" :close-on-click-modal="false")
        .icon-box(@click="$emit('my-close', false)")
            i.el-icon-close
        el-form(:model="ruleForm" label-width="0px")
            el-form-item(prop="oldPassword" :rules="[{ required: true, message: $t('PleaseEnterTheOldPassword'), trigger: 'blur' },{ min: 6, max: 24, message: $t('digitsPassword'), trigger: 'blur' }]")    
                .input-box
                    el-input(:placeholder="$t('PleaseEnterTheOldPassword')" v-model="ruleForm.oldPassword" :type="oldPasswordType" maxlength="24")
                        template(slot="prepend")
                            img(src="@/assets/icon/password-icon.png" )
                        template(slot="append")
                            img.password-status-icon(src="@/assets/icon/hidePass.png" v-if="oldPasswordType==='text'" @click="oldPasswordType='password'")
                            img.password-status-icon(src="@/assets/icon/showPass.png" v-else @click="oldPasswordType='text'")
            el-form-item(prop="newPassword" :rules="[{ required: true, message: $t('PleaseSetTheNewPassword'), trigger: 'blur' },{ min: 6, max: 24, message: $t('digitsPassword'), trigger: 'blur' }]")    
                .input-box
                    el-input(:placeholder="$t('PleaseSetTheNewPassword')" v-model="ruleForm.newPassword" :type="newPasswordType" maxlength="24")
                        template(slot="prepend")
                            img(src="@/assets/icon/auth.png" )
                        template(slot="append")
                            img.password-status-icon(src="@/assets/icon/hidePass.png" v-if="newPasswordType==='text'" @click="newPasswordType='password'")
                            img.password-status-icon(src="@/assets/icon/showPass.png" v-else @click="newPasswordType='text'")
            el-form-item(prop="passwordAgain" :rules="[{ required: true, message: $t('enterTheNewPasswordAgain'), trigger: 'blur' },{ min: 6, max: 24, message: $t('digitsPassword'), trigger: 'blur' }]")    
                .input-box
                    el-input(:placeholder="$t('enterTheNewPasswordAgain')" v-model="ruleForm.passwordAgain" :type="passwordAgainType" maxlength="24")
                        template(slot="prepend")
                            img(src="@/assets/icon/auth.png" )
                        template(slot="append")
                            img.password-status-icon(src="@/assets/icon/hidePass.png" v-if="passwordAgainType==='text'" @click="passwordAgainType='password'")
                            img.password-status-icon(src="@/assets/icon/showPass.png" v-else @click="passwordAgainType='text'")
        span.dialog-footer(slot="footer")
            .botton-box
                el-button(type="primary" @click="changePassWord" :disabled="enableButton") {{$t('Confirm')}}
</template>

<script type="text/ecmascript-6">
import {  Button,  Dialog} from 'element-ui'
import { updateLoginPassword } from '@/service/user-server-rich.js'
import { encrypt } from '@/utils/rsa'
import { exitlogin } from '@/utils/login'

export default {
    name: "",
    model: {
        prop: 'visible',  // 修改 v-model 绑定的props名称
        event: 'my-close'  // 修改 v-model 绑定的自定义事件名
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            ruleForm: {
                oldPassword: '',
                newPassword: '',
                passwordAgain: '',
            },
            oldPasswordType: 'text',
            newPasswordType: 'text',
            passwordAgainType: 'text',
        }
    },
    computed: {
        enableButton() {
            return !this.ruleForm.oldPassword || !this.ruleForm.newPassword || !this.ruleForm.passwordAgain || this.ruleForm.oldPassword.length < 6 || this.ruleForm.newPassword.length < 6 || this.ruleForm.passwordAgain.length < 6
        }
    },
    components: {
        [Button.name]: Button,
        [Dialog.name]: Dialog,
    },
    methods: {
        handleCloseElementDialog() {
            this.$emit('my-close', false)
        },
        async changePassWord() {
            if(this.ruleForm.oldPassword === this.ruleForm.newPassword){
                this.$message({
                    message: this.$t('passwordCannotTheSameOldpassword'),
                    type: 'warning'
                });
                return false
            }
            if(this.ruleForm.newPassword !== this.ruleForm.passwordAgain){
                this.$message({
                    message: this.$t('pleaseEnterTheSamePasswordAgain'),
                    type: 'warning'
                });
                return false
            }
            try{
                await updateLoginPassword({
                    oldPassword: await encrypt(this.ruleForm.oldPassword),
                    password: await encrypt(this.ruleForm.newPassword)
                })
                this.$message({
                    message:this.$t('SuccessfullyModified'),
                    type: 'success'
                });
                exitlogin()
                this.$emit('my-close', false)
            }catch(e){
                this.$message({
                    message: e.msg || this.$t('Fail'),
                    type: 'error'
                });
                return false
            }
        }
    },
    mounted() {
        
    },
}
</script>

<style lang="scss" scoped>
    ::v-deep .el-dialog{
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        margin: 0px !important;
        border-radius: 16px;
        .el-dialog__header{
            text-align: left;
            color: #333;
            font-size: 18px;
        }
        .el-dialog__body{
            color: #555665;
            position: relative;
            padding: 30px 20px 0 20px;
            .icon-box{
                position: absolute;
                right: -48px;
                top: -55px;
                width: 24px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                background: #fff;
                border-radius: 100%;
                cursor: pointer;
                &:hover{
                    color: $--color-primary
                }
            }
            .el-form-item {
                margin-bottom: 20px !important;
            }
            .input-box{
                img{
                    width: 20px;
                    height: 20px
                }
                .password-status-icon{
                    cursor: pointer;
                }
                .el-input-group__prepend{
                    border: none;
                    border-radius: 8px 0 0 8px;
                    padding: 0 0 0 16px;
                    background: #F5F5F5
                }
                .el-input-group__append{
                    border: none;
                    border-radius: 0 8px 8px 0;
                    padding: 0 16px 0 0px;
                    background: #F5F5F5

                }
                .el-input__inner{
                    height: 50px;
                    height: 50px;
                    border: none;
                    background: #F5F5F5;
                    padding:0 8px
                }
            }
        }
        .el-dialog__footer{
            padding-top: 20px;
            .botton-box{
                text-align: center;
                .el-button{
                    width: 100%;
                    height: 50px;
                    padding: 10px 20px;
                    box-sizing: border-box;
                    border-radius: 8px;
                    border: none
                }
                .el-button--default{
                    margin-right: 20px
                }
            }
        }
    }
</style>
